import BaseIvrNode from './baseIvrNode';

export default class VoicemailNode extends BaseIvrNode {
  // temporary commented it
  // we should allow to persist empty selection for Exit & Voicemail nodes ( supernova allows optional selection -> only UI fix )
  // ch - https://app.clubhouse.io/gladly/story/82007/selection-ivr-node-property-must-be-optional
  // @IsNotEmpty({ message: 'Name should not be empty' })
  // @IsString()
  selection: string;
}
